// extracted by mini-css-extract-plugin
export default {"container":"Slider_container__PcZ12","slide":"Slider_slide__jA+q6","image":"Slider_image__VPuZi"};